import { TemplateJobsGeneral } from './../shared/templateJobsGeneral';
import { WallpaperLog } from './../shared/wallpaperLogs.model';
import { DialogDetailedLogsComponent } from './dialog-detailedLogs/dialog.detailedLogs.component';
import { LoggingService } from '../shared/logging.service';
import { AfterViewChecked, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UserLog } from '../shared/UserLog.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { TemplateJobs } from '../shared/templateJobs';
import { softwareUpgradeJob } from '../shared/softwareUpgradeJob';
import { UserTemplateLog } from '../shared/UserTemplateLog.model';
import { ConflictLog } from '../shared/conflictLogs.model';
import { AuditLog } from '../shared/auditLogs.model';
import { DialogDetailedLogsTemplatesComponent } from './dialog-detailedLogsTemplates/dialog.detailedTemplateLogs.component';
import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogDetailedLogsWallpaperComponent } from './dialog-detailedLogs_wallpaper/dialog.detailedLogs_wallpaper.component';

@Component({
  selector: 'app-logging',
  templateUrl: './logging.component.html',
  styleUrls: ['./logging.component.css'],
  providers: [LoggingService]
})
export class LoggingComponent implements OnInit, AfterViewChecked {

  templateLogs: UserTemplateLog[] = [];
  softwareUpgradeLogs: UserLog[] = [];
  upcomingTemplatesLogs: TemplateJobsGeneral[] = [];
  upComingSoftwareUpgradesLogs: softwareUpgradeJob[] = [];
  conflictsLogs: ConflictLog[] = [];
  auditLogs: AuditLog[] = [];
  wallpaperLogs: WallpaperLog[] = [];

  rowColor: string = "bisque";

  templateLogsColumns: string[] = ['job_id', 'job_name', 'ip_address', 'created_at', 'actions'];
  softwareUpgradeLogsColumns: string[] = ['job_id', 'system_name', 'system_ip', 'created_at', 'start_at', 'job_status', 'parent_job_id', 'upgrade_status_last_change', 'upgrade_status_status', 'actions'];
  upcomingTemplatesLogsColumns: string[] = ['job_title', 'template_job_id', 'start_job_at', 'job_creator_editor', 'next_run_time', 'expired', 'template_frequency', 'actions'];
  upComingSoftwareUpgrades: string[] = ['deleteIcon', 'job_id', 'system_ip', 'operation_name', 'start_at', 'system_command'];
  conflictsColumns: string[] = ['conflict_date', 'conflict_ip', 'affected_ip', 'issue', 'action_taken'];
  auditColumns: string[] = ['request_details', 'requested_by', 'requested_at', 'request_state', 'completed_at'];
  wallpaperColumns: string[] = ['job_id', 'endpoint_ip', 'image_id', 'created_by', 'creationDate', 'actions'];

  templateLogsTableData: MatTableDataSource<UserTemplateLog> = new MatTableDataSource([]);
  softwareUpgradeLogsTableData: MatTableDataSource<UserLog> = new MatTableDataSource([]);
  upcomingTemplatesLogsTableData: MatTableDataSource<TemplateJobsGeneral> = new MatTableDataSource([]);
  upComingSoftwareUpgradesTableData: MatTableDataSource<softwareUpgradeJob> = new MatTableDataSource([]);
  conflictsTableData: MatTableDataSource<ConflictLog> = new MatTableDataSource([]);
  auditTableData: MatTableDataSource<AuditLog> = new MatTableDataSource([]);
  wallpaperTableData: MatTableDataSource<WallpaperLog> = new MatTableDataSource([]);



  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();


  constructor(public loggingService: LoggingService,
    private elem: ElementRef,
    public dialog: MatDialog,
    private loggerService: LoggerService,
    private _snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.getTemplateLogs();
    // this.getSoftwareUpgradeLogs();
    // this.getUpcomingTemplatesLogs();
    // this.getUpComingSoftwareUpgrades();
    // this.getConflictLogs();
    // this.getAuditLogs();


  }

  ngAfterViewChecked(): void {
    //to adjust the headers of the table
    //(document.querySelector('.mat-sort-header-container') as HTMLElement).style.justifyContent='center';
    let elements = this.elem.nativeElement.querySelectorAll('.mat-sort-header-container');
    elements.forEach(element => {
      element.style.justifyContent = 'center';
    });
    elements = this.elem.nativeElement.querySelectorAll('th');
    elements.forEach(element => {
      element.style.textAlign = 'center';
      element.style.fontWeight = '800';
      element.style.color = 'black';
      element.style.padding = '4px';
    });
    elements = this.elem.nativeElement.querySelectorAll('td');
    elements.forEach(element => {
      element.style.textAlign = 'center';
      element.style.padding = '4px';
    });
  }

  getTemplateLogs() {
    this.loggingService.getLogs('templates_logs').subscribe({
      next: response => {
        this.templateLogs = response.data;
        this.templateLogsTableData = new MatTableDataSource(this.templateLogs);
        this.templateLogsTableData.paginator = this.paginator.toArray()[0];
        this.templateLogsTableData.sort = this.sort.toArray()[0];
      },
      error: err => {
        this.loggerService.log("LoggingComponent", err.message, Levels.error)
      }
    });
  }

  getSoftwareUpgradeLogs() {
    this.loggingService.getSWLogs('sw_upgrade_logs').subscribe({
      next: response => {
        this.softwareUpgradeLogs = response.data;
        this.softwareUpgradeLogsTableData = new MatTableDataSource(this.softwareUpgradeLogs);
        this.softwareUpgradeLogsTableData.paginator = this.paginator.toArray()[1];
        this.softwareUpgradeLogsTableData.sort = this.sort.toArray()[1];
      },
      error: err => {
        this.loggerService.log("LoggingComponent", err.message, Levels.error)
      }
    })
  }

  getUpcomingTemplatesLogs() {
    this.loggingService.getUpcomingTemplatesJobsData().subscribe({
      next: response => {
        let today = new Date()
        this.upcomingTemplatesLogs = response.data;
        this.upcomingTemplatesLogs.forEach(element => {
          if (Date.parse(element.next_run_time) > Date.parse(today.toString())) {
            element.expired = "No";
          } else {
            element.expired = "Yes";
          }
        });
        this.upcomingTemplatesLogsTableData = new MatTableDataSource(this.upcomingTemplatesLogs);
        this.upcomingTemplatesLogsTableData.paginator = this.paginator.toArray()[2];
        this.upcomingTemplatesLogsTableData.sort = this.sort.toArray()[2];
      },
      error: err => {
        this.loggerService.log("LoggingComponent", err.message, Levels.error)
      }
    })
  }

  getUpComingSoftwareUpgrades() {
    this.loggingService.getUpComingSoftwareUpgrades().subscribe({
      next: response => {
        this.upComingSoftwareUpgradesLogs = response.data;
        this.upComingSoftwareUpgradesTableData = new MatTableDataSource(this.upComingSoftwareUpgradesLogs);
        this.upComingSoftwareUpgradesTableData.paginator = this.paginator.toArray()[3];
        this.upComingSoftwareUpgradesTableData.sort = this.sort.toArray()[3];
      },
      error: err => {
        this.loggerService.log("LoggingComponent", err.message, Levels.error)
      }
    })
  }

  getConflictLogs() {
    this.loggingService.getConflictLogs().subscribe({
      next: response => {
        this.conflictsLogs = response.data;
        this.conflictsTableData = new MatTableDataSource(this.conflictsLogs);
        this.conflictsTableData.paginator = this.paginator.toArray()[4];
        this.conflictsTableData.sort = this.sort.toArray()[4];
      },
      error: err => {
        this.loggerService.log("LoggingComponent", err.message, Levels.error)
      }
    });
  }

  getAuditLogs() {
    this.loggingService.getAuditLogs().subscribe({
      next: response => {
        this.auditLogs = response.data;
        this.auditTableData = new MatTableDataSource(this.auditLogs);
        this.auditTableData.paginator = this.paginator.toArray()[5];
        this.auditTableData.sort = this.sort.toArray()[5];
      },
      error: err => {
        this.loggerService.log("LoggingComponent", err.message, Levels.error)
      }
    });
  }

  getWallpaperLogs() {
    this.loggingService.getWallpaperLogs().subscribe({
      next: response => {
        this.wallpaperLogs = response.data;
        this.wallpaperTableData = new MatTableDataSource(this.wallpaperLogs);
        this.wallpaperTableData.paginator = this.paginator.toArray()[6];
        this.wallpaperTableData.sort = this.sort.toArray()[6];
      },
      error: err => {
        this.loggerService.log("LoggingComponent", err.message, Levels.error)
      }
    });
  }

  clearTemplateLogs() {
    this.templateLogs = [];
    this.templateLogsTableData = new MatTableDataSource(this.templateLogs);
    this.templateLogsTableData.paginator = this.paginator.toArray()[0];
    this.templateLogsTableData.sort = this.sort.toArray()[0];
  }

  clearSoftwareUpgradeLogs() {
    this.softwareUpgradeLogs = [];
    this.softwareUpgradeLogsTableData = new MatTableDataSource(this.softwareUpgradeLogs);
    this.softwareUpgradeLogsTableData.paginator = this.paginator.toArray()[1];
    this.softwareUpgradeLogsTableData.sort = this.sort.toArray()[1];
  }

  clearUpcomingTemplatesLogs() {
    this.upcomingTemplatesLogs = [];
    this.upcomingTemplatesLogsTableData = new MatTableDataSource(this.upcomingTemplatesLogs);
    this.upcomingTemplatesLogsTableData.paginator = this.paginator.toArray()[2];
    this.upcomingTemplatesLogsTableData.sort = this.sort.toArray()[2];
  }

  clearUpcomingSoftwareUpgradesLogs() {
    this.upComingSoftwareUpgradesLogs = [];
    this.upComingSoftwareUpgradesTableData = new MatTableDataSource(this.upComingSoftwareUpgradesLogs);
    this.upComingSoftwareUpgradesTableData.paginator = this.paginator.toArray()[3];
    this.upComingSoftwareUpgradesTableData.sort = this.sort.toArray()[3];
  }

  clearConflictsLogs() {
    this.conflictsLogs = [];
    this.conflictsTableData = new MatTableDataSource(this.conflictsLogs);
    this.conflictsTableData.paginator = this.paginator.toArray()[4];
    this.conflictsTableData.sort = this.sort.toArray()[4];
  }

  clearAuditLogs() {
    this.auditLogs = [];
    this.auditTableData = new MatTableDataSource(this.auditLogs);
    this.auditTableData.paginator = this.paginator.toArray()[5];
    this.auditTableData.sort = this.sort.toArray()[5];
  }

  clearWallpaperLogs() {
    this.wallpaperLogs = [];
    this.wallpaperTableData = new MatTableDataSource(this.wallpaperLogs);
    this.wallpaperTableData.paginator = this.paginator.toArray()[6];
    this.wallpaperTableData.sort = this.sort.toArray()[6];
  }

  applyFilterTemplateLogs(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.templateLogsTableData.filter = filterValue.trim().toLowerCase();
    if (this.templateLogsTableData.paginator) {
      this.templateLogsTableData.paginator.firstPage();
    }
  }

  applyFilterSoftwareUpgradeLogs(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.softwareUpgradeLogsTableData.filter = filterValue.trim().toLowerCase();
    if (this.softwareUpgradeLogsTableData.paginator) {
      this.softwareUpgradeLogsTableData.paginator.firstPage();
    }
  }

  applyFilterUpcomingTemplatesLogs(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.upcomingTemplatesLogsTableData.filter = filterValue.trim().toLowerCase();
    if (this.upcomingTemplatesLogsTableData.paginator) {
      this.upcomingTemplatesLogsTableData.paginator.firstPage();
    }
  }

  applyFilterUpcomingSoftwareUpgradesLogs(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.upComingSoftwareUpgradesTableData.filter = filterValue.trim().toLowerCase();
    if (this.upComingSoftwareUpgradesTableData.paginator) {
      this.upComingSoftwareUpgradesTableData.paginator.firstPage();
    }
  }

  applyFilterConflictsLogs(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.conflictsTableData.filter = filterValue.trim().toLowerCase();
    if (this.conflictsTableData.paginator) {
      this.conflictsTableData.paginator.firstPage();
    }
  }

  applyFilterAuditLogs(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.auditTableData.filter = filterValue.trim().toLowerCase();
    if (this.auditTableData.paginator) {
      this.auditTableData.paginator.firstPage();
    }
  }

  applyFilterWallpaperLogs(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.wallpaperTableData.filter = filterValue.trim().toLowerCase();
    if (this.wallpaperTableData.paginator) {
      this.wallpaperTableData.paginator.firstPage();
    }
  }

  sendIDToDialog(jobId, IP) {
    const dialogRef = this.dialog.open(DialogDetailedLogsComponent, {
      minWidth: '1000px',
      maxWidth: '95vw',
      maxHeight: '100vh',
      data: { jobId: jobId, IP: IP }
    });

  }

  sendTemplateIDToDialog(templateID: string) {
    const dialogRef = this.dialog.open(DialogDetailedLogsTemplatesComponent, {
      minWidth: '1000px',
      maxWidth: '95vw',
      maxHeight: '100vh',
      data: { templateID: templateID }
    });

  }

  sendIDToStateDialog(jobId) {
    const dialogRef = this.dialog.open(DialogDetailedLogsWallpaperComponent, {
      minWidth: '1000px',
      maxWidth: '95vw',
      maxHeight: '100vh',
      data: { jobId: jobId }
    });

  }

  reloadTabData(tabIndex) {
    if (tabIndex == 0) { this.clearTemplateLogs; this.getTemplateLogs(); }
    else if (tabIndex == 1) { this.clearSoftwareUpgradeLogs; this.getSoftwareUpgradeLogs(); }
    else if (tabIndex == 2) { this.clearUpcomingTemplatesLogs; this.getUpcomingTemplatesLogs(); }
    else if (tabIndex == 3) { this.clearUpcomingSoftwareUpgradesLogs(); this.getUpComingSoftwareUpgrades(); }
    else if (tabIndex == 4) { this.clearConflictsLogs(); this.getConflictLogs(); }
    else if (tabIndex == 5) { this.clearAuditLogs(); this.getAuditLogs(); }
    else if (tabIndex == 6) { this.clearWallpaperLogs(); this.getWallpaperLogs(); }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  openDialogRemoveSWUpgrade(element) {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Remove Scheduled SW Upgrade", message: `Confirm the removal of  the scheduled SW upgrade with id: ${element.job_id} and ip address: ${element.system_ip}` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loggingService.removeUpComingSoftwareUpgrade(element.job_id).subscribe(data => {
          this.getUpComingSoftwareUpgrades();
          this.openSnackBar("SW upgrade job removed successfully", "Success");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

}
